module.exports = __webpack_public_path__ + "img/ESERVICE.c528f320.png";